import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import MerchantRequestValidationDatatableRowMeta from "@Modules/terminalManagementSystem/merchant/containers/tableHandlers/merchantRequestValidation/MerchantRequestValidationDatatableRowMeta";
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TMerchantRequestValidationDataTableData = {
    primaryKey: string | number,
    applicationId: string,
    applicationDate: string,
    merchant: string,
    classNumber: string,
    decisionDate: string,
    decidedBy: string,
    merchantProduct: string,
    ADI: string,
    //
    client: string,
    agency: string,
    merchantProductName: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
  handleDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TMerchantRequestValidationDataTableData>()

export function getMerchantRequestValidationDataTableColumns({ isLoading, handleEdit, displayDetails, handleDetails }: Props) {
  
  return [
    columnHelper.accessor("applicationId",
        {
            id: "applicationId",
            header: "ID Application",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("applicationDate",
        {
            id: "applicationDate",
            header: "Date application",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("merchant",
        {
            id: "merchant",
            header: "Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("classNumber",
        {
            id: "classNumber",
            header: "N° Classe",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("decisionDate",
        {
            id: "decisionDate",
            header: "Date décision",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("decidedBy",
        {
            id: "decidedBy",
            header: "Decidé par",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("merchantProduct",
        {
            id: "merchantProduct",
            header: "Produit commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("ADI",
        {
            id: "ADI",
            header: "A.D.I.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                        {MerchantRequestValidationDatatableRowMeta.ADI.options &&
                        MerchantRequestValidationDatatableRowMeta.ADI.options.map((opt, i) => (
                            opt.value == props.getValue() && 
                            <span key={i}>{opt.label}</span>
                        ))}
                </Skeleton>)
            },
        }
    ),
    // *********************************************
    columnHelper.accessor("client",
        {
            id: "client",
            header: "Client",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("agency",
        {
            id: "agency",
            header: "Agence",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("merchantProductName",
        {
            id: "merchantProductName",
            header: "Produit Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleDetails(props.row)}                            
                        >
                            Details
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
